import axios from 'axios';
import notification from 'ant-design-vue/es/notification';
import { debounce } from 'throttle-debounce';
import {baseURL, Network, defaultChain, toHexChainId} from "@/config/constants";

const clearCacheEnterLogin = debounce(500, () => {
  location.reload(); //logout
});

const errorMessage = debounce(500, (message) => {
  if (process.env.NODE_ENV === 'production') {
    console.log(errorMessage);
  } else {
    notification.error({
      message: message,
      duration: 5,
    });
  }
});

/**
 * 多链（v2.1.0）：所有请求默认带上当前选中链，缺省时后端按「默认链（币安链）」处理。
 * ---------------------------------------------------------------------------
 * - 选择结果存在 localStorage（与 store 的 SET_DESIRE_CHAINID 同一个 key）；
 * - 调用方显式传了 chain 就不覆盖（例如 market-detail 按钱包链查询）；
 * - `/api/signature/*` 例外：那类接口的 chain 是**枚举名**（"BSC"），由调用方自己传，
 *   这里注入数字会把签名消息拼错，导致恒报 Signature error。
 */
const CHAIN_STORAGE_KEY = 'predi-chain-id';

function currentChainType() {
  try {
    const hex = localStorage.getItem(CHAIN_STORAGE_KEY);
    // localStorage 里没存过（首次访问）或存的链已被下架 → 回落到默认链（币安链）
    let chain = hex ? Network[hex] : null;
    if (!chain) {
      chain = Network[toHexChainId(defaultChain.chainId)] || null;
    }
    return chain ? chain.chainType : null;
  } catch (e) {
    return null;
  }
}

function hasChain(obj) {
  return !!obj && obj.chain !== undefined && obj.chain !== null && obj.chain !== '';
}

function injectChain(config) {
  if (/\/signature\//.test(config.url || '')) {
    return;
  }
  const chainType = currentChainType();
  if (!chainType) {
    return;
  }
  if (config.data && typeof config.data === 'object' && !(typeof FormData !== 'undefined' && config.data instanceof FormData) && !hasChain(config.data)) {
    config.data.chain = chainType;
  }
  if (config.params && typeof config.params === 'object' && !hasChain(config.params)) {
    config.params.chain = chainType;
  }
}

axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
  baseURL,
  timeout: 600000,
});

service.interceptors.request.use(
  (config) => {
    if (config.data === undefined || config.data === null) {
      config.data = {};
    }
    injectChain(config);
    return config;
  },
  (error) => {
    console.log('configerror', error);
    // Do something with request error
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status === 200 && response.config.responseType === 'blob') {
      if (response.headers['content-disposition'] || (response.headers['content-type'] && response.headers['content-type'].indexOf('application/pdf') != -1)) {
        return response;
      } else {
        const resultBlob = new Blob([response.data], { type: 'application/json' });
        const fr = new FileReader();
        fr.onload = function () {};
        fr.readAsText(resultBlob);
      }
    } else if (response.status === 200) {
      return res;
    } else {
      errorMessage(res.message);
      return Promise.reject(res);
    }
  },
  (err) => {
    if (err === undefined || err.code === 'ECONNABORTED') {
      errorMessage('Response Timeout');
      return Promise.reject(err);
    }
    err.response = err.response || {};
    const status = err.response.status;
    switch (status) {
      case 400:
      case 404:
      case 406:
      case 410:
      case 422:
        // errorMessage('Response Error')
        break;
      case 401:
      case 403:
        clearCacheEnterLogin();
        break;
      case 500:
      case 502:
      case 503:
      case 504:
        // errorMessage('Server Error');
        break;
      default:
        break;
    }
    return Promise.reject(err);
  }
);

export default service;
